// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notify[data-v-53791e68] .el-alert__description {\n  line-height: 1.5;\n}\n", ""]);
// Exports
module.exports = exports;
